'use strict';
var debounce = require('lodash/debounce');
var quantityModuleClass = '.quantity-module';
var quantitySelectClass = '.quantity-select';
var quantityInputClass = '.quantity-input';
var quantityPlusClass = '.quantity-increase';
var quantityMinusClass = '.quantity-decrease';

var exportQuantitySelect = {
    /**
     * Initialize the Quantity Selector widget and Query event handlers.
     */
    initQuantitySelector: function () {
        var qtySelectorInputHandler = function (e) {
            var $qty = $(this).parents(quantityModuleClass);
            var $input = $qty.find(quantityInputClass);
            var $minus = $qty.find(quantityMinusClass);
            var $plus = $qty.find(quantityPlusClass);
            var $qtyInput = $qty.find(quantitySelectClass);
            var quantities = exportQuantitySelect.getQtyArray($qtyInput);
            var currentIndex = quantities.indexOf($qtyInput.val());
            var newIndex;
            var newVal = null;
            var maxQty = $input.attr('max');
            var $errorContainer = $qty.find('.invalid-feedback');

            // if the input field triggered the event but its value didn't change, EXIT
            if ($(this).is($input) && $input.data('previous-value').toString() === $input.val()) {
                return;
            }

            if ($(this).is($minus)) {
                // minus was clicked
                newIndex = currentIndex - 1;
                newVal = quantities[newIndex] ? quantities[newIndex] : quantities[quantities.length - 1];
            } else if ($(this).is($plus)) {
                // plus was clicked
                newIndex = currentIndex + 1;
                newVal = quantities[newIndex];
            } else {
                // was updated via the input text field
                newVal = $(this).val();
                newIndex = quantities.indexOf(newVal);
            }
            if (typeof newVal === 'undefined') {
                return;
            }

            // attempt to change the <input> value
            $qtyInput.trigger({
                type: 'change',
                newVal: newVal
            });

            // if it did not work, reset input field to previous value, show error and EXIT
            if ($qtyInput.val().toString() !== newVal.toString()) {
                e.preventDefault();
                $input.val($input.data('previous-value'));
                $errorContainer.addClass('d-block').html(`The maximum available quantity is ${maxQty}.`);
                exportQuantitySelect.updateTextField($qtyInput);
                return;
            }
            // if it did work, clear error and update input field
            $errorContainer.removeClass('d-block').empty();
            exportQuantitySelect.updateTextField($qtyInput);
        };

        var selectChangeHandler = function (e) {
            var newVal = e.newVal || $(this).val();
            var quantities = exportQuantitySelect.getQtyArray($(this));

            // check if the value exists as an option, and if not, EXIT
            if (quantities.indexOf(newVal) < 0) {
                e.preventDefault();
                return false;
            }
            // set the <select> value
            if ($(this).val() !== newVal) {
                $(this).val(newVal);
            }

            // update the <input> value
            exportQuantitySelect.updateTextField($(this));

            return $(this);
        };

        // init jQuery event handlers
        var plusSelector = quantityModuleClass + ' ' + quantityPlusClass + ':not(.disabled):not([disabled])';
        var minusSelector = quantityModuleClass + ' ' + quantityMinusClass + ':not(.disabled):not([disabled])';
        var inputSelector = quantityModuleClass + ' ' + quantityInputClass + ':not(.disabled):not([disabled])';
        var selectboxSelector = quantityModuleClass + ' ' + quantitySelectClass + ':not(.disabled):not([disabled])';

        $('body').on('change click', plusSelector + ', ' + minusSelector + ', ' + inputSelector, qtySelectorInputHandler);
        $('body').on('change', selectboxSelector, selectChangeHandler);
        $('body').on('keyup', inputSelector, debounce(qtySelectorInputHandler, 1000));
        $('body').on('validateButtons', selectboxSelector, function () { exportQuantitySelect.updateTextField($(this)); });

        $(document).on('keypress', quantityInputClass, function (e) {
            var keyCode = e.which ? e.which : e.keyCode;
            if (!(keyCode >= 48 && keyCode <= 57)) {
                return false;
            }
            if (this.value.length > 2) {
                this.value = this.value.slice(0, 1);
                return false;
            }
            return true;
        });
    },
    /**
     * Get the values of the quantity in a JS array format
     * @param {Object} $qtyInput - a jQuery object representing the <input> element to retrieve values from
     * @return {Object} - Retruns the qty values as an array.
     */
    getQtyArray: function ($qtyInput) {
        var qtys = [];
        for (var i = $qtyInput.attr('min'); i <= $qtyInput.attr('max'); i++) {
            qtys.push(i.toString());
        }
        return qtys;
    },
    /**
     * Updates the displayed value in the widget's text input field.
     * @param {Object} $scope - a jQuery object representing either parent .quantity-module wrapper, or one of its children
     * @return {Object} - Returns the same object param for jQuery function chaining, if needed.
     */
    updateTextField: function ($scope) {
        if ($scope) {
            var $qty = $scope.is(quantityModuleClass) ? $scope : $scope.parents(quantityModuleClass);
            var $qtyInput = $qty.find(quantitySelectClass);
            var $input = $qty.find(quantityInputClass);
            var $plus = $qty.find(quantityPlusClass);
            var $minus = $qty.find(quantityMinusClass);
            var quantities = exportQuantitySelect.getQtyArray($qtyInput);
            var currentIndex = quantities.indexOf($qtyInput.val());

            // disable minus buttons if needed
            if (currentIndex === 0) {
                $minus.addClass('disabled').attr('disabled', 'disabled');
            } else {
                $minus.removeClass('disabled').removeAttr('disabled');
            }

            // disable plus buttons if needed
            if (currentIndex === quantities.length - 1) {
                $plus.addClass('disabled').attr('disabled', 'disabled');
            } else {
                $plus.removeClass('disabled').removeAttr('disabled');
            }

            // update the displayed value
            $input.val($qtyInput.val());

            $input.attr({
                value: $qtyInput.val()
            });
            $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').removeAttr('disabled');
            // reset previous-value tracker
            $input.data('previous-value', $input.val());
        }
        return $scope;
    }
};

module.exports = exportQuantitySelect;
